import { render, staticRenderFns } from "./CustomerBonuses.vue?vue&type=template&id=57524d94"
import script from "./CustomerBonuses.vue?vue&type=script&lang=js"
export * from "./CustomerBonuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports